import { BlockStoreStats } from '#block-store/types';
import { BasicStats, CallStats, getPrintIndentation } from '#common/stats';
export class CompressorStats extends BlockStoreStats {
    static STATS_NAME = 'CompressorStats';
    decompress;
    compress;
    constructor(log) {
        super(CompressorStats.STATS_NAME, log);
        this.decompress = new DecompressStats('decompress', log);
        this.compress = new CompressStats('compress', log);
    }
}
export class DecompressStats extends CallStats {
    uncompressedBytesRead;
    compressedBytesRead;
    constructor(callName, log) {
        super(callName, log);
        this.uncompressedBytesRead = new BasicStats();
        this.compressedBytesRead = new BasicStats();
    }
    toString(indentLevel) {
        let result = super.toString();
        const indentation = getPrintIndentation(indentLevel);
        result += '\n' + indentation;
        result += this.statToString('uncompressedBytesRead', this.uncompressedBytesRead);
        result += '\n' + indentation;
        result += this.statToString('compressedBytesRead', this.compressedBytesRead);
        return result;
    }
    statToString(statName, stat) {
        const total = DecompressStats.toFixed(stat.total());
        const avg = DecompressStats.toFixed(stat.avg());
        return `${this.statsName()} ${statName} total=${total} avg=${avg}`;
    }
}
export class CompressStats extends CallStats {
    uncompressedBytesWritten;
    compressedBytesWritten;
    constructor(callName, log) {
        super(callName, log);
        this.uncompressedBytesWritten = new BasicStats();
        this.compressedBytesWritten = new BasicStats();
    }
    toString(indentLevel) {
        let result = super.toString();
        const indentation = getPrintIndentation(indentLevel);
        result += '\n' + indentation;
        result += this.statToString('uncompressedBytesWritten', this.uncompressedBytesWritten);
        result += '\n' + indentation;
        result += this.statToString('compressedBytesWritten', this.compressedBytesWritten);
        return result;
    }
    statToString(statName, stat) {
        const total = CompressStats.toFixed(stat.total());
        const avg = CompressStats.toFixed(stat.avg());
        return `${this.statsName()} ${statName} total=${total} avg=${avg}`;
    }
}
